import { Grid, Modal, useMediaQuery, IconButton, Box} from '@mui/material'
import React, { useState } from 'react'
import scan from '@meprism/shared/src/assets/icons/scan.svg'
import user from '@meprism/shared/src/assets/icons/participating.svg'
import PieChartCard from './ExecutiveUserPieChartCard'
import ExposureStatsCard from './ExecutiveUserExposureStats'
import { useAppDispatch } from '../../../redux/storeExports'
import { FetchExecutiveUserStats, FetchExecutiveUserOptOuts } from '@meprism/shared/src/redux/peopleFinder/PeopleFinderSlice'
import {theme} from '../../../config/Dashboardtheme'
import closeicon from '@meprism/shared/src/assets/icons/successclose.png'
import ExecutiveUsersDashboardGrid from '../molecule/ExecutiveUsersDashboardGrid'

interface ExposureStatsModalProps {
    muid: any
    open: boolean
    setOpen: (open: boolean) => void
}
interface Stats {
  brokers_found: number
  brokers_in_progress: number
  brokers_removed: number
}

const ExecutiveUserStatsModal = (props: ExposureStatsModalProps) => {
const dispatch = useAppDispatch()
const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
const [userStats, setUserStats] = useState<Stats | null>(null);
const [brokers, setBrokers] = useState<any[]>([]);
const [unmatchedBrokers, setUnmatchedBrokers] = useState<any[]>([]);
const [hasFetched, setHasFetched] = useState<string | null>(null)
const [optOuts, setOptOuts] = useState([])
const [isLoading, setIsLoading] = useState(true)
const handleOpen=async()=>{
  if (hasFetched && hasFetched == props.muid) return
  try {
    setHasFetched(props.muid)
    const aggregatedBrokers = await dispatch(FetchExecutiveUserStats(props.muid)).unwrap()
    setUserStats(aggregatedBrokers.stats)
    setBrokers(aggregatedBrokers.brokers)
    setUnmatchedBrokers(aggregatedBrokers.unmatched_brokers)
    const optouts = await dispatch(FetchExecutiveUserOptOuts(props.muid)).unwrap()
    setOptOuts(optouts)
  } catch (error) {
    console.log(`Error getting profile stats: ${error}`)
  }
  finally{
    setIsLoading(false)
  }
}

if(props.open){
  handleOpen()
}

  const color2 = '#27AE60'
  const color1 = '#E2B93B'

  const handleClose = () => {
    props.setOpen(false)
    setHasFetched(null)
    setUserStats(null)
    setBrokers([])
    setUnmatchedBrokers([])
    setIsLoading(true)
  }
  const defaultModalStyle = {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 10,
    p: 4,
    borderRadius: 5,
    width: isMobile ? '90%' : '70%',
    maxHeight: '90vh',
    minHeight: '90vh', 
    overflowY: 'auto', 
    paddingLeft: '50px',
    paddingRight: '50px',
    paddingTop: '30px',
    paddingBottom: '30px',
  }
  
const getBody=()=>{
  return (
    <Box sx={defaultModalStyle}>
    <IconButton
				edge="end"
				color="inherit"
				onClick={handleClose}
				sx={{
						  position: 'absolute',
							top: 10,
							right: 10,
							zIndex: 1,
							color: '#ffffff',
					}}>
				<img src={closeicon} style={{width: '42px'}}/>
			</IconButton>
      <Grid container mt={10} >
        <Grid item xs={12} md={5.5} marginRight={isMobile? 0: '5%'} marginBottom={isMobile? 3:10}>
          <PieChartCard
            title="Removal Status"
            removed={userStats?.brokers_removed ?? 0}
            removing={userStats?.brokers_in_progress ?? 0}
            color1={color1}
            color2={color2}
            icon1={user}
            bgcolor={''}
            title1={'Removing'}
            title2={'Removed'}
            icon2={scan}
            totalcount1={userStats?.brokers_in_progress ?? 0}
            totalcount2={userStats?.brokers_removed ?? 0}
          />
        </Grid>
        <Grid item xs={12} md={5.5} marginBottom={isMobile? 3:10}>
          <ExposureStatsCard
            title="Exposure Stats"
            removed={125}
            removing={137}
            color1={'#426BF0'}
            color2={'#C67EFF'}
            icon1={user}
            bgcolor={'#C67EFF33'}
            title1={'Profile Found'}
            title2={'Brokers Covered'}
            icon2={scan}
            totalcount1={userStats?.brokers_found ?? 0}
            totalcount2={600}
          />
        </Grid>
      </Grid>
      <Box mt={5}>
        <ExecutiveUsersDashboardGrid Brokers={brokers} unmatchedBrokers={unmatchedBrokers} OptOuts={optOuts} isDataFetched={!isLoading}/>
      </Box>
    </Box>
  )}

  return (
        <Modal
          open={props.open}
          onClose={handleClose}
          sx={{
            backdropFilter: 'blur(5px)',
          }}>
          {getBody()}
        </Modal>
    )

}

export default ExecutiveUserStatsModal
